import { render } from "./singleeventlist.vue?vue&type=template&id=5e228475&scoped=true"
import script from "./singleeventlist.vue?vue&type=script&lang=js"
export * from "./singleeventlist.vue?vue&type=script&lang=js"

import "./singleeventlist.vue?vue&type=style&index=0&id=5e228475&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e228475"]])

export default __exports__